(function () {
  function scrollTabIntoView(tab, tabsContainer, tabs, behavior) {
    if (!tab || !tabsContainer) return;

    var scrollBehavior = behavior || 'smooth';
    var peek = 24;
    var index = Array.prototype.indexOf.call(tabs, tab);
    var scrollWidth = tabsContainer.scrollWidth;
    var clientWidth = tabsContainer.clientWidth;
    var maxScroll = scrollWidth - clientWidth;

    if (maxScroll <= 0) return;

    var target;

    if (index === 0) {
      target = 0;
    } else if (index === tabs.length - 1) {
      target = maxScroll;
    } else {
      target = tab.offsetLeft - peek;
    }

    tabsContainer.scrollTo({
      left: Math.max(0, Math.min(target, maxScroll)),
      behavior: scrollBehavior,
    });
  }

  function initPurecoreProof(root) {
    if (!root || root.dataset.purecoreProofInit === 'true') return;

    var tabsContainer = root.querySelector('[data-purecore-tabs]');
    var tabs = root.querySelectorAll('[data-purecore-tab]');
    var panels = root.querySelectorAll('[data-purecore-panel]');
    if (!tabs.length || !panels.length) return;

    root.dataset.purecoreProofInit = 'true';

    var activateTab = function (tab) {
      var index = tab.getAttribute('data-tab-index');

      tabs.forEach(function (item) {
        var isActive = item.getAttribute('data-tab-index') === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-index') === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      window.requestAnimationFrame(function () {
        scrollTabIntoView(tab, tabsContainer, tabs, 'smooth');
      });
    };

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    var activeTab = root.querySelector('[data-purecore-tab].is-active');
    if (activeTab && tabsContainer) {
      window.requestAnimationFrame(function () {
        scrollTabIntoView(activeTab, tabsContainer, tabs, 'instant');
      });
    }
  }

  function initPurecoreModal() {
    var modal = document.querySelector('[data-purecore-modal]');
    if (!modal || modal.dataset.purecoreModalInit === 'true') return;

    modal.dataset.purecoreModalInit = 'true';

    var dialog = modal.querySelector('.rabitat-purecore-modal__dialog');
    var lastOpener = null;
    var closeTimer = null;
    var MODAL_CLOSE_MS = 380;

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    function openModal(opener) {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      lastOpener = opener || null;
      modal.hidden = false;
      modal.classList.remove('is-open');
      document.documentElement.classList.add('purecore-modal-open');
      initPurecoreProof(modal.querySelector('[data-purecore-proof]'));

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          modal.classList.add('is-open');
          var closeBtn = modal.querySelector('.rabitat-purecore-modal__close');
          if (closeBtn) closeBtn.focus();
        });
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('purecore-modal-open');

      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        modal.hidden = true;
        closeTimer = null;
      }, MODAL_CLOSE_MS);

      if (lastOpener) lastOpener.focus();
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-open-purecore-modal]')) {
        event.preventDefault();
        openModal(event.target.closest('[data-open-purecore-modal]'));
      }
    });

    modal.querySelectorAll('[data-purecore-modal-close]').forEach(function (control) {
      control.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    if (dialog) {
      dialog.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-purecore-proof]').forEach(initPurecoreProof);
    initPurecoreModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-purecore-proof]').forEach(initPurecoreProof);
    initPurecoreModal();
  });
})();
